function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m13.963625 1.90681214 18.0363488-1.90681214 18.0363488 1.90681214 13.9636248 18.74493286-31.9999736 37.2636338-31.9999738-37.2636338z",
  fill: "#fdb300"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 20.651745)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12.9615937 0 19.0384089 37.263646-32.0000026-37.263646z",
  fill: "#ea6c00"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44.9615097 0 19.0384089 37.263646-32.0000026-37.263646z",
  fill: "#ea6c00",
  transform: "matrix(-1 0 0 1 95.999834 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.9615937 0h38.0768178l-19.0384089 37.263646z",
  fill: "#fdad00"
})), /*#__PURE__*/React.createElement("path", {
  d: "m32.0000026 0-18.0364302 1.90678693-1.0019787 18.74494437z",
  fill: "#fdd231"
}), /*#__PURE__*/React.createElement("path", {
  d: "m51.0383132 0-18.0364302 1.90678693-1.0019787 18.74494437z",
  fill: "#fdd231",
  transform: "matrix(-1 0 0 1 83.038218 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50.0362648 20.6517313 13.9637352-18.74494437-1.0021415 18.74494437z",
  fill: "#fdad00",
  transform: "matrix(-1 0 0 1 114.036264 0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 20.6517313 13.9635724-18.74494437-1.0019787 18.74494437z",
  fill: "#fdad00"
}), /*#__PURE__*/React.createElement("path", {
  d: "m32.0000026 0-19.0384089 20.6517313h38.0768178z",
  fill: "#feeeb7"
}));

function SvgIconSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 58,
    viewBox: "0 0 64 58",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSketch);
export default __webpack_public_path__ + "static/media/icon-sketch.042714f4.svg";
export { ForwardRef as ReactComponent };